import type {
  ProductionHistoryCardState,
  ProductionHistoryRecord,
} from './assistant-models'

function updateSelectedIds(
  selectedIds: string[],
  targetIds: string[],
  selected: boolean
): string[] {
  if (selected) return Array.from(new Set([...selectedIds, ...targetIds]))
  return selectedIds.filter((id) => !targetIds.includes(id))
}

export function createProductionHistoryCardState(): ProductionHistoryCardState {
  return { selectedRecordIds: [], exported: false }
}

export function getSelectedProductionHistoryCount(
  state: ProductionHistoryCardState
): number {
  return state.selectedRecordIds.length
}

export function isProductionHistoryAllSelected(
  state: ProductionHistoryCardState,
  records: ProductionHistoryRecord[]
): boolean {
  return (
    records.length > 0 &&
    state.selectedRecordIds.length === records.length
  )
}

export function setProductionHistoryAllSelected(
  state: ProductionHistoryCardState,
  records: ProductionHistoryRecord[],
  selected: boolean
): ProductionHistoryCardState {
  return {
    ...state,
    selectedRecordIds: selected ? records.map((record) => record.id) : [],
  }
}

export function toggleProductionHistoryRecord(
  state: ProductionHistoryCardState,
  recordId: string
): ProductionHistoryCardState {
  const selected = !state.selectedRecordIds.includes(recordId)
  return {
    ...state,
    selectedRecordIds: updateSelectedIds(
      state.selectedRecordIds,
      [recordId],
      selected
    ),
  }
}

export function exportProductionHistorySelections(
  state: ProductionHistoryCardState
): ProductionHistoryCardState {
  return state.selectedRecordIds.length ? { ...state, exported: true } : state
}
